import React, { useCallback, useRef} from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import {  StatusLayout } from '../Layout';


function StatusTab(props) {
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleStatusFieldChange(name, value,e,formRefs);
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='CE7CB18B-F11A-4422-9B86-5BDF0DE92574'
                layoutName='IMLotDataEntryStatusForm'
                defaultFormSchema={StatusLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={()=>props.statusFormLookupsLoad(formRefs)}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(StatusTab);
